import React from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";

const Separator = () => <div styleName="separator" />;

Separator.propTypes = {};

export default CSSModules(Separator, css);
